<pfx-order-form
  [order]="orderUpdateStore.order()"
  [loading]="orderUpdateStore.isPending()"
  (submitForm)="handleSubmit($event)"
></pfx-order-form>
